"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrialBalanceReportTypeIterable = exports.TapeBuilderNodePositionSchema = exports.CreditFacilityContingentLiabilityProducts = exports.ReceivableResponseTapePreviewReportTypeIterable = exports.LenderShareReportTypeIterable = exports.InvoiceReportTypeIterable = exports.FundingRequestReportTypeIterable = exports.CreditFacilityReportTypeIterable = exports.BorrowingBaseServicerReportTypeIterable = exports.BatchSettlementReportTypeIterable = exports.AssignedLoanTapeReportTypeIterable = exports.ComplianceReportCfTypeIterable = exports.MetricKey = exports.MetricKeyIterable = exports.ManualBankAccountReportSource = exports.ManualBankAccountReportSourceIterable = exports.WEBHOOK_EVENT_TYPES = exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = exports.OrganizationWireSchema = exports.OrganizationSchema = exports.BankAccountWithInstitutionSchema = exports.BankInstitutionKeySchema = exports.DocumentTypeIterable = exports.FacilityTypeIterable = exports.TellerEnrollmentStatus = exports.TellerEnrollmentStatusIterable = exports.ComplianceStatusSchema = exports.ComplianceStatusIterable = exports.UserWireSchema = exports.UserSchema = exports.ArtifactWithSlugsSchema = exports.ArtifactInstance = exports.ArtifactDependencyRecordSchema = exports.ArtifactTypeIterable = exports.UserInputTypeSchema = exports.GeneratedArtifactTypeIterable = exports.NON_SHADOWED_TABLES = exports.SANDBOX_ONLY_TABLES = exports.SHADOWED_TABLES = void 0;
const BankTypes = __importStar(require("./Bank"));
const OrganizationTypes = __importStar(require("./Shared/SharedOrganization"));
const zod_1 = require("zod");
// TODO(jon): these are currently sorted in the order they were added to the sandbox. Leaving them
//  this way for now for easy auditing, but once the sandbox stabilizes we should alphabetize.
/**
 * Tables present in both sandbox and live schemas. Definitions must match between schemas and will
 * be checked by the `schemaSync` script.
 */
exports.SHADOWED_TABLES = [
    'borrowing_base_pipeline_artifact_instances',
    'master_loan_tapes',
    'assigned_loan_tapes',
    'receivables',
    'receivable_events',
    'reports',
    'reports_v2',
    'reports_to_entity_map',
    'cash_balances_feed_contexts',
    'cash_balances_feed_screenshots',
    'manual_bank_account_reports',
    'bank_account_reports',
    'cash_response_tapes',
    'borrowing_base_reports',
    'borrowing_base_report_attachments',
    'borrowing_base_report_loan_product_calculations',
    'funding_request_constraints',
    'eligibility_criteria_calculations',
    'concentration_limit_calculations',
    'accounting_accounts',
    'accounting_transactions',
    'accounting_entries',
    'events',
    'event_logs',
    'funding_request_verification_reports',
    'funding_request_approval_reports',
    'funding_requests',
    'funding_request_components',
    'proforma_funding_request_components_map',
    'credit_agreements',
    'credit_agreement_parties',
    'funding_request_receivable_eligibility_verification',
    'borrower_cash_balances_feed',
    'borrowing_base_pipeline_artifact_documents',
    'borrowing_base_pipeline_artifacts',
    'borrowing_base_pipeline_artifact_dependencies',
    'borrowing_base_pipeline_runs',
    'graph_run',
    'borrowing_base_pipeline_deleted_instances', // @pipeline_runs: this is a temporary table for pipeline_run_table migration
    'internal_repayment_tapes',
    'assigned_repayment_tapes',
    'repayment_entries_credit_facility',
    'tape_builder_graph_nodes',
];
/** Tables present in sandbox but not in live. */
exports.SANDBOX_ONLY_TABLES = [];
/** Tables present in live but not in sandbox. */
exports.NON_SHADOWED_TABLES = [
    'assigned_loan_tape_reports',
    'assignment_confirmation_jobs',
    'assignment_strategies',
    'assignment_strategy_loan_product_criteria',
    'async_operations',
    'athena_queries',
    'bank_account_refreshes',
    'bank_accounts',
    'bank_institutions',
    'borrowing_base_pipeline_definitions',
    'borrowing_base_servicer_reports',
    'compliance_reports_cf',
    'cdq_config',
    'cdq_acknowledgements',
    'concentration_limit_multi_loan_product_calculations',
    'connected_organizations',
    'covenant_loan_tapes',
    'credit_facilities_v2_prep',
    'credit_facilities',
    'credit_facility_balance_sheet_data',
    'credit_facility_outstanding_balance_ledger_items',
    'credit_facility_reports',
    'credit_facility_state',
    'org_provided_inputs',
    'org_provided_values',
    // *** Credit Facility Loans ***
    'credit_facility_loan_actions',
    'credit_facility_loan_connections',
    'credit_facility_lender_shares',
    'credit_facility_loans',
    'credit_facility_loan_pricing_options',
    'credit_facility_lender_shares_transactions',
    'credit_facility_lender_share_reports',
    'lender_share_funding_components',
    'credit_facility_batch_settlements',
    'credit_facility_batch_settlement_loan_connections',
    'credit_facility_batch_settlement_reports',
    // *** Credit Facility - Other Products (not loans) ***
    'credit_facility_contingent_liabilities',
    'credit_facility_contingent_liability_transactions',
    'credit_facility_documents',
    'datalake_tables',
    'datalake_hydration_event_jobs',
    'deliverable_tasks',
    'deliverables_artifacts_instances',
    'deliverables_artifacts',
    'deliverables_containers',
    'deliverables_containers_to_threads_mapping',
    'deliverables_containers_receipts',
    'deliverables_containers_receipts_actions_log',
    'deliverables_containers_generate_receipts',
    'deliverables_artifacts_instances_datalake_hydration_status',
    // next two tables are deliverables workflows tables
    'deliverables_containers_receipt_workflows_map',
    'deliverables_containers_receipt_user_approvals',
    'explo_placement_integrations',
    'external_metadata',
    'financial_statement_values',
    'financial_statements',
    'financial_statement_line_items',
    'financial_covenants',
    'finley_ai_knowledge_base_documents',
    'finley_ai_threads',
    'finley_ai_prompt_responses',
    'finley_ai_prompt_templates',
    'funding_request_events',
    'funding_request_reports',
    // following two tables are FR workflow tables
    'funding_request_user_approvals',
    'funding_request_workflow_instance_map',
    `funding_requests_to_threads_mapping`,
    'groups',
    'group_memberships',
    'implementations',
    'implementation_pipelines',
    'invoices',
    'invoice_components',
    'invoice_items',
    'invoice_consolidated_disbursements',
    'invoice_disbursements',
    'invoice_disbursement_items',
    'invoice_disbursement_items_transactions',
    'invoice_payment_in_kind_items',
    'invoice_payment_in_kind_items_transactions',
    'invoice_reports',
    'loan_products',
    'loan_product_balance_sheet_data',
    'materialized_view_configuration',
    'metric_alert_state',
    'metric_alert_thresholds',
    'organizations',
    'api_keys',
    'plaid_asset_report_accounts',
    'plaid_asset_reports',
    'plaid_institution_accounts',
    'plaid_items',
    'portfolio_covenants',
    'railz_financial_api_results',
    'railz_integrations',
    'receivable_documentation_generated',
    'receivable_documentation_raw',
    'receivable_documentation_verification_results',
    'receivable_response_tape_preview_attachments',
    'receivable_response_tape_preview_jobs',
    'receivable_response_tape_previews',
    'receivable_response_tape_preview_reports',
    'reporting_docx_template_customizations',
    'reporting_generate_worklease_status',
    'report_templates',
    'report_xlsx_template_properties',
    'teller_institution_accounts',
    'teller_item',
    'users',
    'webhook_attempts',
    'webhook_subscriptions',
    'valley_bank_van_cust',
    'valley_bank_van_dep_acct',
    'valley_bank_van_cust_acct_rel',
    'valley_bank_van_list',
    'valley_bank_van_product',
    'valley_bank_loan_cust_rel',
    'valley_bank_cuo_deposit',
    'valley_bank_cuo_collat',
    'valley_bank_collat_cust_rel',
    'valley_bank_ps_plus_portfolio',
    'valley_bank_ps_plus_account',
    'valley_bank_ps_plus_sec_detail',
    'valley_bank_ps_plus_sec_master',
    'valley_bank_van_cmmt',
    'valley_bank_van_loan_acct',
    'valley_bank_cuo_loan',
    'valley_bank_cuo_maint',
    'valley_bank_rrt', // FinleyValleyBankResponseTapeRow
    'valley_bank_portfolio_rrt', // portfolio view of rrt
    'valley_bank_assignment_queue',
    'valley_bank_assignment_event_log',
    'valley_bank_collateral_account_stats',
    'valley_bank_loan_account_stats',
    'valley_bank_loan_accounts_to_threads_mapping',
    'valley_bank_historical_loan_account_to_pinned_comment',
    'valley_bank_derivative_path',
    'valley_ibs_api_records',
    'valley_sls_ibs_transaction_tapes',
    'valley_sls_ibs_transactions',
    'valley_sls_ibs_transaction_groups',
    'valley_sls_ibs_transaction_mappings',
    'receivable_borrowing_base_test_waivers',
    'statements',
    'threads',
    'comments',
    'domain_to_threads_mapping',
    'table_preferences',
    'thread_permissions',
    'thread_user_actions_log',
    'workflow_templates',
    'workflow_instances',
    'workflow_nodes',
    'workflow_edges',
    'workflow_actions',
    'workflow_conditions',
    'tasks',
    'permissions',
    'roles',
    'role_permissions',
    'role_assignments',
    'limited_partners',
    'limited_partners_to_loan_product_mapping',
    'limited_partner_match_metadata',
    'limited_partner_tape_records',
    'config_store',
    'attributes',
    'attribute_values',
    'attribute_lists',
    'lender_interest_rates',
    'trial_balance_reports',
];
exports.GeneratedArtifactTypeIterable = [
    'generatedCovenantLoanTape',
    'generatedLoanTape',
    'generatedCashBalanceFeed',
    'generatedRepaymentTape',
    'generatedSupplementalTape',
    'generatedFinancialData',
];
exports.UserInputTypeSchema = zod_1.z.enum([
    'assignement',
    'verificationApproval',
    'dataLakeTableHydration',
    'cashContext',
]);
exports.ArtifactTypeIterable = [
    ...exports.GeneratedArtifactTypeIterable,
    'userInputNeeded', // this task indicates that the pipeline needs input from the user
    'rawLoanTape',
    'rawCashBalanceFeed',
    'rawRepaymentTape',
    'rawSupplementalTape',
    'rawZipTape', // this special raw artifact type is handled by the ingest-organizer-lambda
    'configTape',
    'rawReceivableDocumentation',
    'intermediateTape',
    'internalRepaymentTape',
    'cashResponseTape',
    'cashBalancesFeedContext',
    'masterLoanTape',
    'manualBankAccountReport',
    'assignedLoanTape',
    'assignedRepaymentTape',
    'receivableResponseTapePreview',
    'receivableResponseTape',
    'borrowingBaseReport',
    'directInsertBorrowingBaseReport',
    'directInsertPortfolioCovenant',
    'directInsertPortfolioCovenants',
    'directInsertFinancialCovenants',
    'finStatement',
    'receivableInvoice',
    'fundingVerificationReport',
    'fundingApprovalReport',
    'fundingRequest',
    'receivableDocumentationVerificationReport',
    'forwardedTape',
    'valleyBankIngest',
    'valleyBankSlsIngest',
    'valleyBankSlsCommitment',
    'orgProvidedInput',
    'orgProvidedInputs',
    'uploadToDatalake',
    'waitForDataLakeTable', // task that waits for a data lake table to be ready
    'dataLakeTape', // task that generates a csv file from a data lake query
    'limitedPartnersTape',
];
// unique constraint on outputArtifactId + inputArtifactId
exports.ArtifactDependencyRecordSchema = zod_1.z.object({
    outputArtifactId: zod_1.z.string(), // data tape to create from a list of inputs (dependencies)
    inputArtifactId: zod_1.z.string(), // dependency (an input) to create the output
});
/** Uniqueness constraint exists on the table. */
// Re-export ArtifactInstance as module
const ArtifactInstanceModule = __importStar(require("./ArtifactInstance"));
exports.ArtifactInstance = ArtifactInstanceModule;
// Zod schema for ArtifactWithSlugs
exports.ArtifactWithSlugsSchema = zod_1.z.object({
    // All fields from Artifact except creditFacilityId and loanProductId
    id: zod_1.z.string(),
    artifactSlug: zod_1.z.string(),
    artifactDocumentId: zod_1.z.string(),
    type: zod_1.z.string(), // ArtifactType, but as string for schema
    externalFilename: zod_1.z.string().nullable(),
    configuration: zod_1.z.object({}),
    // Add the slug fields
    creditFacilitySlug: zod_1.z.string().nullable(),
    loanProductSlug: zod_1.z.string().nullable(),
});
// Users
exports.UserSchema = zod_1.z.object({
    id: zod_1.z.string(),
    created_at: zod_1.z.date(),
    updated_at: zod_1.z.date(),
    isActive: zod_1.z.boolean(),
    email: zod_1.z.string(),
    password: zod_1.z.string().optional(),
    userType: OrganizationTypes.UserTypeSchema,
    // NOTE:
    // organizationId will likely go away in the future, and we will manage
    // N:M relationship between user<>organizations
    organizationId: zod_1.z.string(),
    roleType: OrganizationTypes.UserRoleTypeSchema,
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    // this eventually can become required, but for safety we will make optional in all types for now
    // our codebase does not explicitly need to be aware for this for now [with exception of any strict runtime type checks]
    isAiAgentEnabled: zod_1.z.boolean().optional(), // can this is user use the n8n service, used by n8n for authN
});
// Wire schema for JSON schema generation (uses string datetime instead of Date)
exports.UserWireSchema = zod_1.z.object({
    id: zod_1.z.string(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
    isActive: zod_1.z.boolean(),
    email: zod_1.z.string(),
    password: zod_1.z.string().optional(),
    userType: OrganizationTypes.UserTypeSchema,
    organizationId: zod_1.z.string(),
    roleType: OrganizationTypes.UserRoleTypeSchema,
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
    isAiAgentEnabled: zod_1.z.boolean().optional(),
});
// ============================================================================
// COMPLIANCE STATUS SCHEMA
// ============================================================================
exports.ComplianceStatusIterable = [
    'COMPLIANT',
    'LIMIT_WARNING',
    'LIMIT_REACHED',
    'WAIVED',
];
exports.ComplianceStatusSchema = zod_1.z.enum(exports.ComplianceStatusIterable);
exports.TellerEnrollmentStatusIterable = [
    'connected',
    'disconnected',
    'accountLocked',
    'inactive',
    'credentialsInvalid',
    'captchaRequired',
    'mfaRequired',
    'webLoginRequired',
];
exports.TellerEnrollmentStatus = {
    Connected: 'connected', // the default status, means the connection is live and healthy
    Disconnected: 'disconnected',
    AccountLocked: 'accountLocked',
    Inactive: 'inactive',
    CredentialsInvalid: 'credentialsInvalid',
    CaptchaRequired: 'captchaRequired',
    MfaRequired: 'mfaRequired',
    WebLoginRequired: 'webLoginRequired', // the current enrollment (connection) status
};
exports.FacilityTypeIterable = [
    'creditFacility',
    'forwardFlow',
    'securitization',
    'capitalCallLine',
    'backupServicing',
];
/******************** CreditFacility Document Types ********************/
exports.DocumentTypeIterable = [
    'creditAgreement',
    'participationAgreement',
];
const DocumentStatusIterable = ['latestPublished', 'published'];
exports.BankInstitutionKeySchema = zod_1.z.string();
const BankAccountSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
    isActive: zod_1.z.boolean(),
    implementationId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    plaidAccountId: zod_1.z.optional(zod_1.z.string().nullable()),
    tellerAccountId: zod_1.z.optional(zod_1.z.string().nullable()),
    bankInstitutionId: zod_1.z.string(),
    routingNumber: zod_1.z.string(),
    accountNumber: zod_1.z.string(),
    currencyCode: BankTypes.CurrencyCodeSchema,
});
const ImplementationBankAccountSchema = BankAccountSchema.extend({
    implementationId: zod_1.z.string(),
    // @implementation: support API integrations with implementation-owned bank accounts.
    // This will require split auth - implementation owner owns the bank account, but the
    // real life bank account owner owns the API integration.
    plaidAccountId: zod_1.z.null(),
    tellerAccountId: zod_1.z.null(),
});
exports.BankAccountWithInstitutionSchema = BankAccountSchema.extend({
    institutionName: zod_1.z.string(),
    bankInstitutionKey: exports.BankInstitutionKeySchema,
});
exports.OrganizationSchema = OrganizationTypes.BaseOrganizationSchema.extend({
    // In the DB, these are nullable to allow temporarily breaking a circular FK reference between
    // orgs and groups. In regular operation, this should never be null.
    ownerGroupId: zod_1.z.string(),
    allUsersGroupId: zod_1.z.string(),
    type: OrganizationTypes.OrganizationTypeSchema,
    isBackup: zod_1.z.boolean().optional(),
    industry: zod_1.z.string().optional(),
    created_at: zod_1.z.date(),
    updated_at: zod_1.z.date(),
});
// Wire schema for JSON schema generation (uses string datetime instead of Date)
exports.OrganizationWireSchema = OrganizationTypes.BaseOrganizationSchema.extend({
    ownerGroupId: zod_1.z.string(),
    allUsersGroupId: zod_1.z.string(),
    type: OrganizationTypes.OrganizationTypeSchema,
    isBackup: zod_1.z.boolean().optional(),
    industry: zod_1.z.string().optional(),
    created_at: zod_1.z.string().datetime(),
    updated_at: zod_1.z.string().datetime(),
});
exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES = ['assignment.assign'];
exports.WEBHOOK_EVENT_TYPES = [
    ...exports.ASSIGNMENT_WEBHOOK_EVENT_TYPES,
    'fundingRequest.approved',
    'borrowingBaseReport.generated',
];
exports.ManualBankAccountReportSourceIterable = [
    'adminDashboard',
    'borrowerDashboard',
    'borrowerS3Upload',
];
exports.ManualBankAccountReportSource = {
    AdminDashboard: 'adminDashboard',
    BorrowerDashboard: 'borrowerDashboard',
    BorrowerS3Upload: 'borrowerS3Upload',
};
exports.MetricKeyIterable = ['collateralCovenantLtv'];
exports.MetricKey = {
    collateralCovenantLtv: 'collateralCovenantLtv',
};
// At the moment, this would generally align with "ReportConfigTypeIterable" in
// "CreditAgreement.DomainEntity", potentially being a subset of it.
exports.ComplianceReportCfTypeIterable = [
    'monthlyServicerReport',
];
exports.AssignedLoanTapeReportTypeIterable = [
    'receivablesSaleAgreement',
];
exports.BatchSettlementReportTypeIterable = ['batchSettlement'];
exports.BorrowingBaseServicerReportTypeIterable = [
    'borrowingBaseServicerReport',
];
exports.CreditFacilityReportTypeIterable = ['assetVerification'];
exports.FundingRequestReportTypeIterable = [
    'borrowingBaseCertificate',
    'fundingRequestServicerReport',
    'noticeOfBorrowing',
    'noticeOfPrepayment',
    'releaseNotice',
];
exports.InvoiceReportTypeIterable = [
    'invoice',
    'disbursementNotice',
    'paymentInKindNotice',
];
exports.LenderShareReportTypeIterable = ['fundingNotice'];
exports.ReceivableResponseTapePreviewReportTypeIterable = [
    'receivableResponseTapePreviewServicerReport',
];
const threadDomains = [
    'fundingRequest.request',
    'valleyBank.loanAccountNumber',
    'deliverables.container',
    'limitedPartner',
    'invoice',
];
exports.CreditFacilityContingentLiabilityProducts = [
    'letterOfCredit',
];
exports.TapeBuilderNodePositionSchema = zod_1.z.object({
    artifactIdentifier: zod_1.z.string(),
    x: zod_1.z.number(),
    y: zod_1.z.number(),
});
exports.TrialBalanceReportTypeIterable = [
    'facilityTrialBalance',
    'loanTrialBalance',
];
//# sourceMappingURL=DbTables.js.map